import { SvgIcon, SvgIconProps } from '@mui/material';

const PointsFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PointsFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 13C17 11.3431 18.3431 10 20 10C21.6569 10 23 11.3431 23 13C23 14.6569 21.6569 16 20 16C18.3431 16 17 14.6569 17 13Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 8C2 6.34315 3.34315 5 5 5C6.65685 5 8 6.34315 8 8C8 9.65685 6.65685 11 5 11C3.34315 11 2 9.65685 2 8Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 20C14 18.3431 15.3431 17 17 17C18.6569 17 20 18.3431 20 20C20 21.6569 18.6569 23 17 23C15.3431 23 14 21.6569 14 20Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M4 17C4 14.7909 5.79086 13 8 13C10.2091 13 12 14.7909 12 17C12 19.2091 10.2091 21 8 21C5.79086 21 4 19.2091 4 17Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9 6C9 3.23858 11.2386 1 14 1C16.7614 1 19 3.23858 19 6C19 8.76142 16.7614 11 14 11C11.2386 11 9 8.76142 9 6Z" />
    </SvgIcon>
  );
};

export default PointsFilled;
